import React, { useState } from 'react';
import { Play, X, Youtube } from 'lucide-react';
import { Reveal } from '../components/Reveal';
import { useContent } from '../context/ContentContext';

function PlayerModal({ video, onClose }) {
  if (!video) return null;
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full max-w-4xl">
        <button onClick={onClose} className="absolute -top-11 right-0 text-white/80 hover:text-white flex items-center gap-1.5 text-sm">
          Close <X size={20} />
        </button>
        <div className="relative w-full rounded-2xl overflow-hidden shadow-2xl" style={{ paddingBottom: '56.25%' }}>
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${video.videoId}?autoplay=1&rel=0`}
            title={video.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
        <div className="mt-4 text-white">
          <p className="font-display text-xl">{video.title}</p>
          <p className="text-white/60 text-sm mt-1">{video.guest}</p>
        </div>
      </div>
    </div>
  );
}

export default function Podcasts() {
  const { podcasts } = useContent();
  const [active, setActive] = useState(null);
  return (
    <div className="pt-32 md:pt-40 pb-24">
      <div className="section-pad">
        <div className="max-w-[1500px] mx-auto">
          <Reveal>
            <div className="flex items-center gap-2 mb-4">
              <Youtube size={18} className="text-[#D01919]" />
              <p className="eyebrow text-[#D01919]">The Enersider Podcast</p>
            </div>
            <h1 className="font-display text-6xl md:text-8xl leading-none">Conversations that carry.</h1>
            <p className="text-[#666666] text-lg mt-6 max-w-xl">
              Candid, long-form dialogue with the people shaping the energy transition — streamed from our studio to yours.
            </p>
          </Reveal>

          <div className="grid md:grid-cols-3 gap-8 mt-14">
            {podcasts.map((p, i) => (
              <Reveal key={p.videoId} delay={i * 90}>
                <button onClick={() => setActive(p)} className="group text-left w-full">
                  <div className="relative rounded-2xl overflow-hidden aspect-video bg-black">
                    <img src={`https://img.youtube.com/vi/${p.videoId}/hqdefault.jpg`} alt={p.title} className="card-img w-full h-full object-cover opacity-90" />
                    <div className="absolute inset-0 bg-black/25 group-hover:bg-black/10 transition-colors" />
                    <span className="absolute inset-0 flex items-center justify-center">
                      <span className="w-16 h-16 rounded-full bg-[#D01919] text-white flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform duration-300">
                        <Play size={26} className="ml-1" fill="currentColor" />
                      </span>
                    </span>
                  </div>
                  <h3 className="font-display text-2xl mt-4 group-hover:text-[#D01919] transition-colors leading-snug">{p.title}</h3>
                  <p className="text-[#666666] text-sm mt-2">{p.description}</p>
                  <p className="text-xs text-[#111111] font-medium mt-3">{p.guest}</p>
                </button>
              </Reveal>
            ))}
          </div>

          <div className="mt-14 text-center">
            <a href="https://www.youtube.com/@Enersider" target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#111111] text-white font-medium px-6 py-3.5 rounded-full hover:bg-[#D01919] transition-colors">
              <Youtube size={18} /> Visit our YouTube channel
            </a>
            <p className="text-[#666666] mt-5 text-sm">Want to feature on the podcast? For editorial opportunities, write to <a href="mailto:editor@enersider.com" className="text-[#D01919] font-medium">editor@enersider.com</a></p>
          </div>
        </div>
      </div>
      <PlayerModal video={active} onClose={() => setActive(null)} />
    </div>
  );
}
